import React from "react";
import { Button, styled } from "@mui/material";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

const StyledSendButton = styled(Button)(({ theme, comment }) => ({
  minWidth: '120px',
  height: '36px',
  fontWeight: 500,
  fontSize: '15px',
  lineHeight: '20px',
  marginLeft: '22px',
  borderRadius: '6px',
  textTransform: 'none',
  boxShadow: comment === "" 
    ? '0 1px 3px rgba(0, 0, 0, 0.1)' 
    : '0 4px 12px rgba(0, 0, 0, 0.15)',
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    transform: comment !== "" ? 'translateY(-1px) scale(1.02)' : 'none',
    boxShadow: comment !== "" 
      ? '0 6px 16px rgba(0, 0, 0, 0.2)' 
      : '0 2px 6px rgba(0, 0, 0, 0.1)',
  },
  '&:active': {
    transform: comment !== "" ? 'translateY(0) scale(0.98)' : 'none',
  },
}));

const StyledCancelButton = styled(Button)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '15px',
  lineHeight: '20px',
  textTransform: 'none',
  color: theme?.palette?.text?.secondary || '#666',
  backgroundColor: 'transparent',
  minWidth: 'auto',
  padding: '8px 16px',
  borderRadius: '6px',
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    backgroundColor: theme?.palette?.action?.hover || 'rgba(0, 0, 0, 0.04)',
    color: theme?.palette?.text?.primary || '#333',
  },
}));

export const SendButton = ({ comment, onClick }) => {
  const intl = useIntl();

  const commentText = intl.formatMessage({
    id: "comments.comment",
  });

  return (
    <StyledSendButton 
      variant="contained"
      disabled={comment === ""}
      onClick={onClick}
      comment={comment}
    >
      {commentText}
    </StyledSendButton>
  );
};

SendButton.defaultProps = {
  comment: "",
};

SendButton.propTypes = {
  comment: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export const CancelButton = ({ onClick }) => {
  const intl = useIntl();
  const cancelCommentText = intl.formatMessage({
    id: "comments.cancel",
  });
  return (
    <StyledCancelButton 
      variant="text"
      onClick={onClick}
    >
      {cancelCommentText}
    </StyledCancelButton>
  );
};

CancelButton.defaultProps = {};

CancelButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
